import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Checkbox } from 'emerald-ui';
import SignUpFormAddress from '../SignUpFormAddress';

class SignUpFormMailingAddress extends Component {
  transformations = {
    streetAddress: 'mailStreetAddress',
    houseNumber: 'mailHouseNumber',
    country: 'mailCountry',
    city: 'mailCity',
    state: 'mailState',
    zipCode: 'mailZipCode',
    isAddressOutsideUS: 'mailIsAddressOutsideUS',
  };

  onMailAddressSameAsPhysicalChange = (event) => {
    const checked = event.target.checked;
    this.props.handleFieldChange({ isMailAddressSameAsPhysical: checked });
  };

  handleChange = (newObj) => {
    const keys = Object.keys(newObj);
    if (keys.length === 0) {
      return false;
    }
    let transformed = {};
    const transformations = this.transformations;
    keys.forEach((key) => {
      transformed[transformations[key]] = newObj[key];
    });
    this.props.handleFieldChange(transformed);
  };

  render() {
    const {
      streetAddress = {},
      houseNumber = {},
      country = {},
      city = {},
      state = {},
      zipCode = {},
      isMailAddressSameAsPhysical,
      isAddressOutsideUS,
    } = this.props;

    return (
      <Row>
        <Col xs={12} md={5} className="sign-up-form-description">
          <p>Mailing address</p>
          <p>Enter your primary mailing address</p>
        </Col>
        <Col xs={12} md={7} className="sign-up-fields-section">
          <Row className="sign-up-fields-section">
            <Col xs={12}>
              <Checkbox
                id="isMailAddressSameAsPhysical"
                label="Mailing address is same as physical"
                defaultChecked={isMailAddressSameAsPhysical}
                onChange={this.onMailAddressSameAsPhysicalChange}
              />
            </Col>
          </Row>
          {!isMailAddressSameAsPhysical && (
            <SignUpFormAddress
              handleFieldChange={this.handleChange}
              streetAddress={streetAddress}
              houseNumber={houseNumber}
              country={country}
              city={city}
              state={state}
              zipCode={zipCode}
              isAddressOutsideUS={isAddressOutsideUS}
            />
          )}
        </Col>
      </Row>
    );
  }
}

SignUpFormMailingAddress.propTypes = {
  handleFieldChange: PropTypes.func,
};

SignUpFormMailingAddress.defaultProps = {
  handleFieldChange: () => {},
};

export default SignUpFormMailingAddress;



// WEBPACK FOOTER //
// ./src/components/SignUpFormMailingAddress/SignUpFormMailingAddress.js